function parseDiamondTitle(title) {
  if (!title) return null;

  let cut = "";
  let carat = "";
  let clarity = "";
  let color = "";
  let gia = "";

  const partsGlobal = title.split("-");
  gia = partsGlobal[partsGlobal.length - 1].trim();
  const partsCaratCut = partsGlobal[0].trim().toLowerCase().split("ct.");
  const tempCut = partsCaratCut[1].trim();
  cut = tempCut.charAt(0).toUpperCase() + tempCut.slice(1);
  carat = `${partsCaratCut[0]} Ct.`;
  const partsColorClarity = partsGlobal[1].trim().split("/");
  color = partsColorClarity[0].trim();
  clarity = partsColorClarity[1].trim();

  return { cut, carat, clarity, color, gia };
}

if (!customElements.get("diamond-details")) {
  class ProductCardRebuyComponent extends HTMLElement {
    constructor() {
      super();
      this.graphQLUrl = this.dataset.graphqlUrl;
      this.graphQLToken = this.dataset.graphqlToken;
      this.bundleProducts = this.dataset.bundleProducts;
      this.loaded = false;
      this.initObserver();
    }

    initObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!this.loaded) this.loadDetails();
          }
        });
      });
      this.observer.observe(this);
    }

    async loadDetails() {
      const productIds = this.bundleProducts.split(",");
      const data = {
        query: `
          query BundleProducts {
            firstProduct:product(id:"${productIds[0]}") {
              title
            }
            secondProduct:product(id:"${productIds[1]}") {
              title
            }
          }
        `,
      };
      const response = await fetch(this.graphQLUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.graphQLToken,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      const bundleProductsData = responseData.data;
      const bundleDiamond = Object.keys(bundleProductsData).find(
        (key) => bundleProductsData[key].title.indexOf("Setting") < 0
      );
      const diamondDetails = parseDiamondTitle(
        bundleProductsData[bundleDiamond]?.title
      );
      let diamondDetailsHtml = "";
      if (diamondDetails) {
        diamondDetailsHtml = `
        <div class="extra-data">
            <div class="data-element label">Cut</div>
            <div class="data-element label medium-down--hide">Carat Weight</div>
            <div class="data-element label large--hide">Carat</div>
            <div class="data-element label">Clarity</div>
            <div class="data-element label">Color</div>
            <div class="data-element">${diamondDetails.cut}</div>
            <div class="data-element">${diamondDetails.carat}</div>
            <div class="data-element">${diamondDetails.clarity}</div>
            <div class="data-element">${diamondDetails.color}</div>
        </div>
        `;
      }

      this.loaded = true;

      if (diamondDetailsHtml !== "") this.innerHTML = diamondDetailsHtml;
    }
  }
  customElements.define("diamond-details", ProductCardRebuyComponent);
}

if (!customElements.get("rebuy-sale-tag")) {
  class ProductCardRebuySaleTag extends HTMLElement {
    constructor() {
      super();
      this.graphQLUrl = this.dataset.graphqlUrl;
      this.graphQLToken = this.dataset.graphqlToken;
      this.handle = this.dataset.handle;
      this.additionalClasses = this.dataset.additionalClasses;
      this.customerTier = this.dataset.customerTier;
      this.loaded = false;
      this.initObserver();
    }
    initObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!this.loaded) this.loadSaleTags();
          }
        });
      });
      this.observer.observe(this);
    }
    async loadSaleTags() {
      const data = {
        query: `
          query ProductBadges {
            product(handle:"${this.handle}") {
              saleTag:metafield(namespace:"custom",key:"sale_tag") {
                value
              }
              saleTagVip:metafield(namespace:"custom",key:"sale_tag_vip") {
                value
              }
              saleTagDiamond:metafield(namespace:"custom",key:"sale_tag_diamond") {
                value
              }
            }
          }
        `,
      };
      const response = await fetch(this.graphQLUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.graphQLToken,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      const productSaleTagData = responseData.data;
      this.buildSaleTags(
        this.customerTier,
        productSaleTagData,
        this.additionalClasses
      );
      this.loaded = true;
    }
    handleize(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes

      return str;
    }
    buildSaleTags(customerTier, saleTags) {
      let saleTag = "";
      if (saleTags.product?.saleTag?.value)
        saleTag = saleTags.product?.saleTag?.value;
      if (customerTier === "diamond") {
        if (saleTags.product?.saleTagDiamond?.value) {
          saleTag = saleTags.product?.saleTagDiamond?.value;
        } else if (saleTags.product?.saleTagVip?.value) {
          saleTag = saleTags.product?.saleTagVip?.value;
        }
      }
      if (customerTier == "vip") {
        if (saleTags.product?.saleTagVip?.value) {
          saleTag = saleTags.product?.saleTagVip?.value;
        }
      }
      if (saleTag !== "") {
        let saleTagEl = document.createElement("div");
        saleTagEl.classList.add("badge", "badge-sale-tag");
        if (this.additionalClasses) {
          this.additionalClasses
            .split(" ")
            .forEach((c) => saleTagEl.classList.add(c));
        }
        saleTagEl.innerHTML = saleTag;
        this.appendChild(saleTagEl);
      }
    }
  }
  customElements.define("rebuy-sale-tag", ProductCardRebuySaleTag);
}

if (!customElements.get("rebuy-product-badges")) {
  class ProductCardRebuyBagdes extends HTMLElement {
    constructor() {
      super();
      this.graphQLUrl = this.dataset.graphqlUrl;
      this.graphQLToken = this.dataset.graphqlToken;
      this.handle = this.dataset.handle;
      this.badgesSettings = this.dataset.badgesSettings;
      this.loaded = false;
      this.initObserver();
    }

    initObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!this.loaded) this.loadBadges();
          }
        });
      });
      this.observer.observe(this);
    }

    async loadBadges() {
      const data = {
        query: `
          query ProductBadges {
            product(handle:"${this.handle}") {
              tags
              metafield(namespace:"custom",key:"product_badges") {
                value
              }
            }
          }
        `,
      };
      const response = await fetch(this.graphQLUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.graphQLToken,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      const productBadgesData = responseData.data;
      this.buildBadges(productBadgesData);
      this.loaded = true;
    }
    handleize(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes

      return str;
    }
    buildBadges(badgesDataMetafield) {
      let badgesData =
        badgesDataMetafield.product &&
        badgesDataMetafield.product.metafield &&
        badgesDataMetafield.product.metafield.value
          ? badgesDataMetafield.product.metafield.value.split(",")
          : null;
      if (!badgesData) return;
      let badgesLimit = 3;
      let badgestType = "all";
      let badgeCount = 0;
      let sale = "";
      let available = true;

      let badgesHtml = [];
      let badges = this.badgesSettings;

      if (badgestType === "all" || badgestType === "custom") {
        badgesHtml = badges
          .split(",")
          .map((badge) => badge.trim())
          .map((badge) => {
            if (badgesData.includes(badge)) {
              return {
                handle: this.handleize(badge),
                badge,
              };
            }
          })
          .splice(0, badgesLimit)
          .filter((badge) => typeof badge !== "undefined");
      }

      // Adding Final Farewell tag
      if (badgesDataMetafield.product && badgesDataMetafield.product.tags) {
        if (badgesDataMetafield.product.tags.includes("Final Farewell")) {
          badgesHtml = [
            ...badgesHtml,
            {
              handle: "final-sale",
              badge: "Final Sale",
            },
          ];
        }
      }

      badgesHtml.forEach((badgeData) => {
        var divBadge = document.createElement("div");
        divBadge.innerHTML = badgeData.badge;
        divBadge.classList.add("badge");
        divBadge.classList.add(badgeData.handle);
        this.appendChild(divBadge);
      });
    }
  }
  customElements.define("rebuy-product-badges", ProductCardRebuyBagdes);
}

if (!customElements.get("rebuy-recommendations")) {
  class RebuyRecommendationsComponent extends HTMLElement {
    constructor() {
      super();

      this.graphQLUrl = this.dataset.graphqlUrl;
      this.graphQLToken = this.dataset.graphqlToken;
      this.sectionId = this.dataset.sectionId;
      this.cardClasses = this.dataset.cardClasses;
      this.badgesSettings = this.dataset.badgesSettings;
      this.customerTier = this.dataset.customerTier;
      this.showSaleTag = this.dataset.showSaleTag === "true";

      this.elWrapper = this.parentNode.querySelector(".keen-slider");
    }

    buildOptions(product) {
      let optionIndex = 0;
      let colorSwatchOptions =
        "ColorMetal Color";
      let optionsHtml = product.options
        .filter((option) => option.name.indexOf("Color") > 0)
        .map((option, indexOption) => {
          return `
        <div class="inline-swatch-group swatch-group product-swatch color-swatches flex flex-wrap" 
              role="group" 
              aria-label="${option.name}">${this.buildSwatches(
            indexOption,
            product
          )}
        </div>
        `;
        })
        .join("");
      return optionsHtml;
    }

    buildSwatches(indexOption, product) {
      let values = [];
      let countSwatches = 0;
      var swatchesHtml = product.variants
        // .filter((variant) => variant.available)
        .map((variant) => {
          let value = variant[`option${indexOption + 1}`];

          if (!values.includes(value)) {
            let variantImageUrl = "";
            let priceCompare = "";
            let priceFinal = 0;
            values = values.join("*|*");
            values = values + "*|*" + value;
            values = values.split("*|*");
            variantImageUrl = product.images.find(
              (image) => image.id === variant.image_id
            )?.src;
            priceCompare = `$${parseFloat(
              variant.compare_at_price
            ).toLocaleString()}`;
            priceFinal = `$${parseFloat(variant.price).toLocaleString()}`;
            return `<div class="swatch">
          <input class="visually-hidden" id="swatch-${this.sectionId}-${
              product.id
            }-${this.handleize(value)}" type="radio" 
            name="swatch-${product.id}" 
            value="${value}" 
            data-variant-url="/products/${product.handle}?variant=${
              variant.id
            }" 
            data-price-final="${priceFinal}" 
            data-variant-img="${variantImageUrl}"
             />
          <label class="animation color color-${this.handleize(
            value
          )}" for="swatch-${this.sectionId}-${product.id}-${this.handleize(
              value
            )}">
            <div class="animation label-inner">
              <span class="visually-hidden">${value}</span>
            </div>
          </label>
        </div>`;
          }
          return ``;
        })
        .join("");
      return swatchesHtml;
    }

    handleize(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes

      return str;
    }

    buildImages(product) {
      let productImage = product.image;
      // let imagesHtml = `<div class="img-wrap">
      //   ${product.images
      //     .map((image) => {
      //       return `<img
      //       class="img main lazyload"
      //       alt=""
      //       data-sizes="auto"
      //       src="${image.src}"
      //       srcset=""
      //       width="${image.width}" height="${image.height}" />`;
      //     })
      //     .join("")}
      // </div>`;
      return productImage
        ? `<img 
            class="img main lazyload" 
            alt="" 
            data-sizes="auto" 
            src="${productImage.src}"
            srcset=""
            width="${productImage.width}" height="${productImage.height}" />`
        : "";
      return imagesHtml;
    }

    init(products) {
      this.elWrapper.innerHTML = products
        .map((product) => {
          const variantPrices = product.variants.map((variant) => ({
            price: parseFloat(variant.price),
            compareAtPrice: variant.compare_at_price
              ? parseFloat(variant.compare_at_price)
              : 0,
          }));
          const priceMin = variantPrices.sort((a, b) =>
            a.price > b.price ? 1 : -1
          )?.[0];
          const priceMax = variantPrices.sort((a, b) =>
            a.price > b.price ? -1 : 1
          )?.[0];
          const compareAtPriceMin = variantPrices.sort((a, b) =>
            a.compareAtPrice > b.compareAtPrice ? -1 : 1
          )?.[0];
          const compareAtPriceMax = variantPrices.sort((a, b) =>
            a.compareAtPrice > b.compareAtPrice ? 1 : -1
          )?.[0];
          return `
          <div class="keen-slider-slide">
          <product-card class="product-card common-card trigger-floating-buttons text-left flex direction-column ${
            this.cardClasses
          }">
            <div class="image-container ease-animation">
              <a href="/products/${
                product.handle
              }" class="product-card-url no-highlight-hover ignore-slide-tabindex" tabindex="-1">
                ${this.buildImages(product)}
                <div class="visually-hidden">${product.title}</div>
                <div class="product-badges flex"><rebuy-product-badges
                    data-badges-settings="${this.badgesSettings}"
                    data-graphql-url="${this.graphQLUrl}" data-graphql-token="${
            this.graphQLToken
          }" data-handle="${product.handle}"></rebuy-product-badges></div>
              </a>
            </div>
            <div class="info flex direction-column">
              <a href="/products/${
                product.handle
              }" class="product-card-url no-highlight-hover">
                <div class="info-inner">
                  <div class="title flex-1">${product.title}</div>
                  ${
                    product.variants?.[0]?.metafields?.custom?.extra_details
                      ? product.variants[0].metafields.custom.extra_details
                      : ""
                  }
                </div>
              </a>
              ${
                this.showSaleTag
                  ? `<rebuy-sale-tag
              data-additional-classes="large--hide medium--hide small--flex"
              data-customer-tier="${this.customerTier}"
              data-graphql-url="${this.graphQLUrl}" 
              data-graphql-token="${this.graphQLToken}" data-handle="${product.handle}"
              ></rebuy-sale-tag>`
                  : ""
              }
              <div class="bottom-prod flex justify-content-between align-items-center">
              
                <div class="flex align-items-center">
                  <div class="price flex">
                    ${
                      priceMin.price != priceMax.price
                        ? `<div class="from">From</div>`
                        : ``
                    }
                    <span class="compare ${
                      priceMin.price != priceMax.price ||
                      compareAtPriceMin.compareAtPrice === 0 ||
                      compareAtPriceMin.compareAtPrice === priceMin.price ||
                      !compareAtPriceMin.compareAtPrice
                        ? `hide`
                        : ""
                    }">$${compareAtPriceMin.compareAtPrice.toLocaleString()}</span>
                    <span class="final">$${priceMin.price.toLocaleString()}</span>
                  </div>
                  
                </div>
                ${
                  this.showSaleTag
                    ? `<rebuy-sale-tag
                data-additional-classes="large--flex medium--flex small--hide"
                data-customer-tier="${this.customerTier}"
                data-graphql-url="${this.graphQLUrl}" 
                data-graphql-token="${this.graphQLToken}" data-handle="${product.handle}"
                ></rebuy-sale-tag>`
                    : ""
                }
                ${this.buildOptions(product)}
                
              </div>

              ${
                product.metafields.custom?.bundle_products
                  ? `<diamond-details data-graphql-url="${
                      this.graphQLUrl
                    }" data-graphql-token="${
                      this.graphQLToken
                    }" data-bundle-products="${eval(
                      product.metafields.custom.bundle_products
                    ).join(",")}"></diamond-details>`
                  : ""
              }
              
              <div class="description hide">
                --description--
              </div>
            </div>
          </product-card>
          </div>
        `;
        })
        .join("");

      let elComponentCarousel =
        this.parentNode.querySelector("component-carousel");
      if (elComponentCarousel) {
        // elComponentCarousel.removeSlider();
        elComponentCarousel.refresh();
        setTimeout(() => {
          elComponentCarousel.initSlider();
        }, 500);
      }
    }
  }
  customElements.define("rebuy-recommendations", RebuyRecommendationsComponent);
}
